import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

function formatDate(date, locale) {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date)
}

function StepHeader({ classes, translate, hidden, reservationId, locale, dateIn, dateOut }) {
  return (
    <Paper square elevation={0} className={classes.header}>
      <div className={classes.div} style={{ display: hidden ? 'none' : 'flex' }}>
        <Typography className={classes.title} component="p">
          {translate('reservationLabel')}
          <br /> {reservationId}
        </Typography>
        <Typography className={classes.title} component="p">
          Check in
          <br /> {formatDate(dateIn, locale)}{' '}
        </Typography>
        <Typography className={classes.title} component="p">
          Check out
          <br /> {formatDate(dateOut, locale)}{' '}
        </Typography>
      </div>
    </Paper>
  )
}

const styles = (theme) => ({
  header: {
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: '#303e46',
    width: '100%',
    overflow: 'hidden'
  },
  title: {
    color: '#fff',
    fontSize: '11px',
    width: '33.3%',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflowWrap: 'break-word',
    padding: 2
  },
  div: {
    display: 'flex',
    textAlign: 'center'
  }
})

export default withStyles(styles)(withTranslate(StepHeader))
